import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ManagementService {

  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }

  /**
   * obtiene las entidades
   * @param token: string
   * @param road: number
   */
  loginManagement(login, token) {
    const body = {
      user: login.user,
      pass: login.pass
    };

    return this.http.post<any>(environment.url + '/MG/Login', body,
      { headers: this.headers.set('recaptchaR', token) }).pipe(retry(1), catchError(this.errorHandl));
  }

  /**
   * Control errores generico para todas las llamadas
   * @param error: Object
   */
  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
